module.exports = __webpack_public_path__ + "static/media/bitcom_logo.ba475056.png";